<template>
  <div class="content-wrapper">
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="100">
      <exhibitionList :datas="dataList"></exhibitionList>
      <loading :loading="loading" :loaded="loaded"></loading>
    </div>
  </div>
</template>
<script>
import infiniteScroll from 'vue-infinite-scroll'
import exhibitionList from '../common/exhibitionList'
import loading from '../common/loading'
import { getExhibitionList } from '@/api/zaiart'
export default {
  components: { exhibitionList, loading },
  data: () => ({
    dataList: [],
    loading: false, // 加载中
    loaded: false, // 加载结束
    param: {
      page: { index: 1, size: 10 }
    }
  }),
  directives: { infiniteScroll },
  methods: {
    init() {
      this.getListData()
    },
    getListData() {
      let param = this.param
      this.loading = true
      return getExhibitionList(param).then(response => {
        if (response.data.list && response.data.list.length) {
          this.dataList = this.dataList.concat(response.data.list)
          this.loading = false
        } else {
          this.loaded = true
        }
      })
    },
    loadMore() {
      this.param.page.index++
      this.getListData()
    }
  },
  created() {
    this.init()
  }
}
</script>
<style scoped>
.content-wrapper {
  padding-top: 40px;
}
</style>
